<template>
  <div class="OrderList">
    <GlobalInfoBar title="串号查询明细" />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <OrderFrom :mold="mold" />
      </div>
      <div class="caseOrder">
        <OrderTable ref="tableBody" @mold-change="handleMoldChange" />
      </div>
    </GlobalChunk>
  </div>
</template>

<script>
import _api from "@/utils/request";
import OrderFrom from "./Form";
import OrderTable from "./Table";
export default {
  name: "OrderList",
  components: { OrderFrom, OrderTable },
  data() {
    return {
      classList: null,
      merchantId: "",
      UnPayUserOrders: 0,
      mold: "1",
    };
  },
  created() {},
  methods: {
    // 同步当前业务页签，控制顶部筛选项的显示范围
    handleMoldChange(mold) {
      this.mold = mold;
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.OrderList {
  .caseOrder {
    margin: 0 5px;
    // background: #f5f6fa;
    border-radius: 10px;
  }
}
</style>
